export class CommunicationRecord {
  public CommunicationId: number = 0;
  public MessageId: number = 0;
  public ProfileId: number = 0;
  public Member: boolean = false;
  public OrgInd: boolean = false;
  public ContactId: number = 0;
  public Email: boolean = false;
  public Fax: boolean = false;
  public SendTo: string = '';
  public SendCc: string = '';
  public SendBcc: string = '';
  public FaxNum: string = '';
  public SendToDisplayName: string = '';
  public EmailResponse: string = '';
  public TotalRead: number = 0;
}
